import { Link } from "react-router-dom";
import { Apple } from "lucide-react";

export const NfpLogo = ({ className = "" }) => (
  <Link to="/" className={`flex items-center gap-2.5 group ${className}`} data-testid="nfp-logo">
    <span className="relative inline-flex items-center justify-center w-10 h-10 rounded-lg border border-white/15 bg-black overflow-hidden">
      <svg viewBox="0 0 40 40" className="w-7 h-7" fill="none" aria-hidden="true">
        {/* Italic "NF" monogram with electric-blue diagonal slash */}
        <g style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontStyle: "italic" }}>
          <text x="3" y="28" fontSize="22" fill="#C8CFD6">N</text>
          <text x="18" y="28" fontSize="22" fill="#FFFFFF">F</text>
        </g>
        <line
          x1="34"
          y1="6"
          x2="6"
          y2="36"
          stroke="#1FA2FF"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
      </svg>
    </span>
    <div className="leading-none">
      <div className="nfp-heading text-white text-lg tracking-[0.14em]">NFP</div>
      <div className="text-[9px] text-white/50 tracking-[0.22em] uppercase mt-0.5">
        Nofatigue Programming
      </div>
    </div>
  </Link>
);

export const AppStoreBadge = ({ href = "https://apps.apple.com/", testId = "app-store-badge", variant = "primary" }) => {
  const base =
    "inline-flex items-center gap-3 px-5 py-3 rounded-2xl transition-all duration-300 will-change-transform";
  const styles =
    variant === "primary"
      ? "bg-white text-black hover:-translate-y-0.5 hover:shadow-[0_18px_40px_-12px_rgba(255,255,255,0.35)]"
      : "bg-black border border-white/20 text-white hover:border-white/40 hover:-translate-y-0.5";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${base} ${styles}`}
    >
      <Apple className="w-7 h-7" strokeWidth={1.5} />
      <span className="text-left leading-tight">
        <span className="block text-[10px] uppercase tracking-[0.2em] opacity-70">Download on the</span>
        <span className="block text-lg font-semibold -mt-0.5">App Store</span>
      </span>
    </a>
  );
};
